import { useModal } from "matsuri-ui"
import { useCallback } from "react"
import { AlreadyTakenDialog } from "./AlreadyTakenDialog"

export const useAlreadyTakenDialog = () => {
    const [openAlreadyTakenDialog, closeModal] = useModal(AlreadyTakenDialog, {
        size: "sm"
    })

    return {
        openAlreadyTakenDialogWhenApproving: useCallback(
            () =>
                openAlreadyTakenDialog({
                    onClose: closeModal,
                    actionType: "approve"
                }),
            [closeModal, openAlreadyTakenDialog]
        ),
        openAlreadyTakenDialogWhenRejecting: useCallback(
            () =>
                openAlreadyTakenDialog({
                    onClose: closeModal,
                    actionType: "reject"
                }),
            [closeModal, openAlreadyTakenDialog]
        )
    }
}
